export const kioskDevicesResource = {
  name: '付款亭',
  fields: {
    id: 'ID',
    siteId: '場地',
    siteName: '場地',
    name: '名稱',
    status: '狀態',
    apiKeySuffix: 'API 金鑰',
    nearbyChargerIds: '附近充電機',
    octopusDeviceId: '八達通裝置編號',
    lastHeartbeatAt: '最後心跳',
    health: '健康狀態',
    appVersion: '應用程式版本',
    launcherVersion: '啟動器版本',
    updateState: '更新狀態',
    updateStateAt: '更新狀態起始',
    updateError: '更新錯誤',
    settlementDueSince: '待結算起始',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    maintenanceEnabled: '維護模式',
  },
  status: { pending: '待登記', active: '使用中', disabled: '已停用' },
  maintenance: {
    chip: '維護中',
    switchLabel: '維護模式',
    helperText: '開啟後此付款亭會停在維護畫面，直至關閉。進行中的充電不受影響。',
    enabled: '已開啟維護模式',
    disabled: '已關閉維護模式',
  },
  health: {
    reader: '八達通讀卡器', terminal: '刷卡終端機', printer: '打印機', paper: '紙張', clock: '時鐘',
    ok: '正常', absent: '未設定', error: '錯誤', low: '偏低', out: '缺紙', unknown: '未知',
    skewMs: '時鐘偏差 %{ms} 毫秒', offline: '離線', online: '在線', neverSeen: '從未連線',
  },
  sections: { basicInfo: '基本資料', hardware: '硬件', status: '狀態', settings: '設定', enrollment: '登記' },
  list: { subtitle: '自助充電付款亭及其健康狀態' },
  create: {
    title: '登記付款亭',
    subtitle: '建立付款亭記錄並取得一次性登記碼',
    siteHelperText: '只列出已開放付款亭的場地',
    nameHelperText: '顯示於管理後台及收據，例如「大堂付款亭」',
    nearbyChargersHelperText: '最接近此付款亭的充電機，會優先顯示',
    octopusDeviceIdHelperText: '可選。留空時登記後會自動填入讀卡器裝置編號',
  },
  edit: {
    title: '付款亭',
    issueCode: '發出新登記碼',
    issueCodeConfirm: '此操作會撤銷付款亭現有憑證，必須以新登記碼重新登記。是否繼續？',
    codeIssued: '已發出登記碼',
    disable: '停用付款亭',
    enable: '啟用付款亭',
  },
  enrollment: {
    title: '登記碼',
    body: '請在付款亭輸入此登記碼。只會顯示一次，24 小時後失效。',
    expires: '%{when} 到期',
    copy: '複製登記碼',
    copied: '已複製',
    done: '完成',
  },
  settings: {
    title: '設定',
    key: '設定項目',
    value: '數值',
    source: '來源',
    authority: '權限',
    scope: { default: '預設', system: '系統', site: '場地', kiosk: '此付款亭' },
    authorityClass: { cloud: '管理後台', device: '裝置' },
    override: '為此付款亭覆寫',
    clear: '清除此付款亭覆寫',
    saved: '已儲存',
    cleared: '已清除',
    invalid: '數值無效',
    jsonHint: '請以 JSON 格式輸入（數字、true/false、"文字"、[清單] 或 {物件}）',
    kioskScopeNotAllowed: '由支援人員設定',
  },
  errors: {
    KIOSK_SITE_NOT_ENABLED: '請先在場地開放付款亭',
    KIOSK_NOT_FOUND: '找不到付款亭',
    KIOSK_SETTING_INVALID_VALUE: '此設定的數值無效',
    KIOSK_SETTING_SCOPE_NOT_ALLOWED: '此設定不可在此層級設定',
  },
};
export const kioskDevices = kioskDevicesResource;
